import styled from 'styled-components';

const accentColor = (props) =>
  props.$accent === 'eba' ? 'var(--cco-blue)' : 'var(--cco-orange)';
const accentSoft = (props) =>
  props.$accent === 'eba' ? 'var(--cco-blue-soft)' : 'var(--cco-orange-soft)';

export const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  width: 100%;
`;

export const PeriodToggle = styled.div`
  display: inline-flex;
  align-self: flex-start;
  padding: 3px;
  gap: 2px;
  border-radius: 8px;
  background: var(--cco-soft-surface);
  border: 1px solid var(--cco-line);
`;

export const PeriodBtn = styled.button`
  padding: 5px 14px;
  border: none;
  border-radius: 6px;
  background: ${(props) => (props.$active ? accentSoft(props) : 'transparent')};
  color: ${(props) => (props.$active ? accentColor(props) : 'var(--cco-ink-mute)')};
  font-size: 11.5px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  cursor: pointer;
  font-family: inherit;
  transition: background 150ms, color 150ms;

  &:hover {
    color: ${accentColor};
  }
`;

export const Kpis = styled.div`
  display: flex;
  align-items: stretch;
  gap: 0;
  flex-wrap: wrap;
`;

export const Kpi = styled.div`
  flex: 1 1 0;
  min-width: 110px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 4px 14px;

  &:first-child {
    padding-left: 0;
  }
`;

export const Sep = styled.span`
  width: 1px;
  align-self: stretch;
  background: var(--cco-line);
  flex-shrink: 0;
`;

export const KpiLabel = styled.span`
  font-size: 11px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  font-weight: 600;
  color: var(--cco-ink-mute);
`;

export const KpiValue = styled.span`
  font-size: 24px;
  font-weight: 700;
  line-height: 1.05;
  color: var(--cco-ink);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;

  small {
    font-size: 14px;
    color: var(--cco-ink-mute);
    font-weight: 600;
    margin-left: 3px;
  }
`;

export const Empty = styled.div`
  font-size: 13px;
  color: var(--cco-ink-faint);
  padding: 8px 0;
`;

// Estado saudavel: periodo sem paradas/falhas. Verde com check — comunica
// "tudo certo" em vez de uma fileira de "—" que parece quebrado.
export const Ok = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
  color: var(--cco-green);
  padding: 6px 0;

  > svg {
    width: 15px;
    height: 15px;
    flex-shrink: 0;
  }
`;
